import React, { useState, useRef, useEffect } from 'react';
import { Input } from './ui/input';
import { MapPin, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AddressAutocomplete = ({ value, onChange, onSelect, placeholder, testid }) => {
  const [predictions, setPredictions] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);
  const boxRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleType = (text) => {
    onChange(text);
    if (timer.current) clearTimeout(timer.current);
    if (!text || text.length < 3) {
      setPredictions([]);
      setOpen(false);
      return;
    }
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/shipping/address/autocomplete`, { params: { input: text } });
        setPredictions(res.data.predictions || []);
        setOpen(true);
      } catch (e) {
        setPredictions([]);
      } finally {
        setLoading(false);
      }
    }, 350);
  };

  const pick = async (p) => {
    setOpen(false);
    onChange(p.description);
    try {
      const res = await axios.get(`${API}/shipping/address/place-details`, { params: { place_id: p.place_id } });
      onSelect(res.data);
    } catch (e) {
      /* ignore */
    }
  };

  return (
    <div className="relative" ref={boxRef}>
      <div className="relative">
        <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input
          data-testid={testid}
          value={value}
          onChange={(e) => handleType(e.target.value)}
          onFocus={() => predictions.length && setOpen(true)}
          placeholder={placeholder || 'Inizia a digitare l\'indirizzo...'}
          className="pl-9"
          autoComplete="off"
        />
        {loading && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 animate-spin" />}
      </div>
      {open && predictions.length > 0 && (
        <ul
          data-testid={`${testid}-predictions`}
          className="absolute z-30 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-xl overflow-hidden"
        >
          {predictions.map((p) => (
            <li
              key={p.place_id}
              onClick={() => pick(p)}
              className="px-4 py-2.5 text-sm text-slate-700 hover:bg-blue-50 cursor-pointer flex items-center gap-2 transition-colors"
            >
              <MapPin className="w-3.5 h-3.5 text-blue-500 shrink-0" />
              {p.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
